import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../components/shared/SectionHeader';
import { FilterBar } from '../components/shared/FilterBar';
import { EquipmentCard } from '../components/shared/EquipmentCard';
export function EquipmentPage() {
  const [activeFilter, setActiveFilter] = useState('all');
  const equipment = [{
    name: 'Wheel Loader (966H)',
    category: 'heavy',
    image: 'https://images.unsplash.com/photo-1581094271901-8022df4466f9?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Wheel Loader (950H)',
    category: 'heavy',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Excavator (330DL)',
    category: 'heavy',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Excavator (320DL)',
    category: 'heavy',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&q=80',
    status: 'in-use' as const
  }, {
    name: 'Motor Grader (140K)',
    category: 'heavy',
    image: 'https://images.unsplash.com/photo-1581092162384-8987c1d64718?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Bulldozer (D6T)',
    category: 'heavy',
    image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Lowbed Trailer (60 Tons)',
    category: 'transport',
    image: 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Lowbed Trailer (80 Tons)',
    category: 'transport',
    image: 'https://images.unsplash.com/photo-1519003722824-194d4455a60c?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Concrete Mixer (10/7)',
    category: 'concrete',
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Concrete Mixer (7/5)',
    category: 'concrete',
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=600&q=80',
    status: 'in-use' as const
  }, {
    name: 'Concrete Pump',
    category: 'concrete',
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Drilling Machine',
    category: 'specialized',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Bathymetric Unit',
    category: 'specialized',
    image: 'https://images.unsplash.com/photo-1581092162384-8987c1d64718?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'GPS Rover',
    category: 'survey',
    image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Digital Scanner',
    category: 'survey',
    image: 'https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Total Station',
    category: 'survey',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&q=80',
    status: 'in-use' as const
  }, {
    name: 'Compactor Roller',
    category: 'heavy',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Vibrating Roller',
    category: 'heavy',
    image: 'https://images.unsplash.com/photo-1581092162384-8987c1d64718?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Backhoe Loader',
    category: 'heavy',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Dump Truck (20 Tons)',
    category: 'transport',
    image: 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Water Tanker',
    category: 'transport',
    image: 'https://images.unsplash.com/photo-1519003722824-194d4455a60c?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Generator (500 KVA)',
    category: 'power',
    image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=600&q=80',
    status: 'available' as const
  }, {
    name: 'Generator (250 KVA)',
    category: 'power',
    image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=600&q=80',
    status: 'available' as const
  }];
  const filterOptions = [{
    value: 'all',
    label: 'All Equipment'
  }, {
    value: 'heavy',
    label: 'Heavy Machinery'
  }, {
    value: 'transport',
    label: 'Transport'
  }, {
    value: 'concrete',
    label: 'Concrete'
  }, {
    value: 'survey',
    label: 'Survey'
  }, {
    value: 'specialized',
    label: 'Specialized'
  }, {
    value: 'power',
    label: 'Power'
  }];
  const filteredEquipment = activeFilter === 'all' ? equipment : equipment.filter(e => e.category === activeFilter);
  return <div className="min-h-screen pt-20" data-id="element-388">
      <SectionHeader title="Equipment & Technology" subtitle="State-of-the-art machinery and equipment for every project need" data-id="element-389" />

      <section className="py-16 sm:py-20 md:py-24" data-id="element-390">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-391">
          <FilterBar options={filterOptions} activeFilter={activeFilter} onFilterChange={setActiveFilter} data-id="element-392" />

          <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-393">
            {filteredEquipment.map((item, index) => <motion.div key={item.name} layout initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} data-id="element-394">
                <EquipmentCard name={item.name} image={item.image} status={item.status} index={index} data-id="element-395" />
              </motion.div>)}
          </motion.div>
        </div>
      </section>
    </div>;
}